import { createContext, useContext } from "react";
import type { DesignVersion } from "./resolve";
export const DesignContext = createContext<DesignVersion>("legacy");
export const useDesignVersion = () => useContext(DesignContext);
